// index.ts
import { useXAi } from "./context/AiProviderContext";
import XAiProvider from "./components/XAiProvider";
import XAiChatbot from "./components/XAiChatbot";
import XAiSDK from "./components/XAiSDK";
import XAiSender from "./components/XAiSender";
import FileGallery from "./components/FileGallery";
import XAiConversations from "./components/XAiConversations";
import XAdkThoughtChain from "./components/XAdkThoughtChain";
import useXAiSDK from "./hooks/useXAiSDK";
import request from "./utils/request";
import {
  formatMarkdownResourceLinksAsText,
  getMarkdownResourceDisplayLabel,
  parseMarkdownResourceLinksAsParts,
  parseMarkdownResourceHref,
  replaceMarkdownResourceLinks,
} from "./utils/markdownResource";

// 新的 Compound Components 架构
import XAdkProvider from "./components/XAdkProvider";
import XAdkChatbot from "./components/XAdkChatbot";
import XAdkSender from "./components/XAdkSender";
import useADKChat from "./hooks/useADKChat";
import {
  baseChatStrategies,
  basePreset,
  baseToolKindResolver,
  BUILTIN_CHAT_PRESETS,
  composeChatPresets,
  DEFAULT_CHAT_PRESET_NAME,
  defineChatPreset,
  mergeChatStrategies,
  resolvePresetUploadRequest,
  resolveChatPreset,
  resolvePresetMarkdownExtensions,
} from "./presets";
import {
  extractXGroupKnowledgeReferences,
  parseXGroupKnowledgeReference,
  xGroupKnowledgeReferenceMarkdownExtension,
  xGroupMarkdownExtensions,
  parseXGroupWebReference,
  xGroupWebReferenceMarkdownExtension,
  createXGroupUploadRequest,
  xGroupAdkPreset,
  xGroupToolKindResolver,
} from "./presets/xgroup";

// 导出新的 Context Hooks
export {
  useChatState,
  useChatActions,
  useSession,
} from "./components/XAdkProvider/context";

export * from "./types";

// 导出自定义 Hook 相关类型
export type { ChatHookResult, ChatHookFactory } from "./types/ChatHook";

// 旧 API - 保持向后兼容
export {
  useXAi,
  XAiProvider,
  XAiChatbot,
  XAiSDK,
  XAiSender,
  XAiConversations,
  useXAiSDK,
  request,
};

// 新 API - 推荐使用
export {
  XAdkProvider,
  XAdkChatbot,
  XAdkSender,
  FileGallery,
  XAdkThoughtChain,
  useADKChat,
  formatMarkdownResourceLinksAsText,
  getMarkdownResourceDisplayLabel,
  parseMarkdownResourceLinksAsParts,
  parseMarkdownResourceHref,
  replaceMarkdownResourceLinks,
  baseChatStrategies,
  basePreset,
  baseToolKindResolver,
  BUILTIN_CHAT_PRESETS,
  composeChatPresets,
  DEFAULT_CHAT_PRESET_NAME,
  defineChatPreset,
  createXGroupUploadRequest,
  mergeChatStrategies,
  resolvePresetUploadRequest,
  resolveChatPreset,
  resolvePresetMarkdownExtensions,
  extractXGroupKnowledgeReferences,
  parseXGroupKnowledgeReference,
  xGroupKnowledgeReferenceMarkdownExtension,
  xGroupMarkdownExtensions,
  parseXGroupWebReference,
  xGroupWebReferenceMarkdownExtension,
  xGroupAdkPreset,
  xGroupToolKindResolver,
};
export type {
  XGroupKnowledgeReference,
  XGroupWebReference,
} from "./presets/xgroup";

// Sources 来源引用组件
import Sources from "./components/Sources";
export { Sources };
export type { SourcesProps, SourcesItem, SourcesRef } from "./types/Sources";

// FolderTree 文件树组件
import FolderTree from "./components/FolderTree";
export { FolderTree };
export type {
  FolderTreeProps,
  FolderTreeData,
  FileContentService,
  FolderTreeRef,
} from "./components/FolderTree";

// 基础组件导出 - 供高级用户和业务侧使用
export { default as MarkdownRender } from "./components/XAdkChatbot/components/MarkdownRender";
export { default as FunctionCallRender } from "./components/XAdkChatbot/components/FunctionCallRender";
export { default as ThinkRender } from "./components/XAdkChatbot/components/ThinkRender";

// 基础组件类型导出
export type { MarkdownRenderProps } from "./components/XAdkChatbot/components/MarkdownRender";
export type { FunctionCallRenderProps } from "./types/FunctionCallRender";
export type {
  XAdkThoughtChainProps,
  ThoughtChainItemType,
  ThoughtChainStatus,
} from "./types/XAdkThoughtChain";

// 设计令牌导出 - 供引用方覆盖样式
export { tokens, tokenDefaults, token, cssVarStyle } from "./styles/tokens";

// Headless ADK data-flow APIs
export * from "./core";
export { default as useAdkConversation } from "./react/useAdkConversation";
export type { UseAdkConversationResult } from "./react/useAdkConversation";
export { createXGroupOpenApiTransport } from "./presets/xgroup";
export type { XGroupOpenApiTransportOptions } from "./presets/xgroup";
